import { combineReducers } from "redux"
import { createLeiCodeReducer } from "./createLeiCodeReducer"
import { dataFormReducer } from "./dataFormReducer"

export const rootReducer = combineReducers({
    leiCode: createLeiCodeReducer,
    dataForm: dataFormReducer
})

export type RootState = ReturnType<typeof rootReducer>